import React from 'react';
import { connectModal, hide } from 'redux-modal';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import catchError from '../../utils/catchError';
import { editSpot } from '../../actions/parkingSpotActions';
import ParkingSpotForm from './ParkingSpotForm';

function EditParkingSpotModal({ id, handleHide }) {
  const dispatch = useDispatch();
  const spot = useSelector((state) => state.spots[id]);

  async function handleSubmit(values, { resetForm }) {
    try {
      await dispatch(
        editSpot({
          ...values,
          ...{
            id: spot.placeId,
          }
        })
      );

      toast.success(`Upravili jste parkovací místo ${values.place}`);
      handleHide();
      resetForm();
    } catch (err) {
      catchError(err);
    }
  }

  function handleCancel() {
    dispatch(hide('editParkingSpotModal'));
  }

  if(!spot) return <div />

  return (
    <div className="modal">
      <div className="modal__container">
        <div className="modal__body">
          <h2>Upravit parkovací místo</h2>
          <ParkingSpotForm
            initialValues={{
              lot: spot.parkingLotId,
              place: spot.place,
              owner: spot.permanentUserId,
              floor: spot.floor
            }}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default connectModal({ name: 'editParkingSpotModal' })(
  EditParkingSpotModal
);
